export const BaseAPI = 'https://api.himalayantrailrunning.com/api'
export const MediaAPI = 'https://api.himalayantrailrunning.com/'
// const BaseAPI = 'http://localhost:8000/api/v1'
